import cloneDeep from "lodash/cloneDeep";
import api from "../util/api";
import * as actions from "../store/modules/comissao/actions";
import {
  notifyWarn,
  notifySuccess,
  notifyInfo,
} from "../components/message/message";
import { maskDate, maskMoeda, removeMaskMoeda } from "../util/masks";
import { setLoading } from "../store/modules/globalLoading/actions";

function formatarData(data) {
  return data
    ? data.substring(8, 10) +
        "/" +
        data.substring(5, 7) +
        "/" +
        data.substring(0, 4)
    : "";
}

function mesmoId(a, b) {
  return String(a).toLowerCase() === String(b).toLowerCase();
}

export function getTipoComissaoBancoId(evento) {
  return evento.tiposComissaoBanco
    ? evento.tiposComissaoBanco.id
    : evento.tiposComissaoBancoId;
}

export async function get(pesquisa, pageSize, page, ordenacao = {}) {
  if (
    (pesquisa.dataInicioVigencia !== "" && pesquisa.dataFimVigencia === "") ||
    (pesquisa.dataInicioVigencia === "" && pesquisa.dataFimVigencia !== "")
  ) {
    notifyWarn("Informe as duas datas (De / Até) para filtrar.");
    return;
  }

  const params = { pagina: page, registros: pageSize };

  if (pesquisa.statusTabela !== "") params.StatusTabela = pesquisa.statusTabela;
  if (pesquisa.descricao.trim() !== "")
    params.Descricao = pesquisa.descricao.trim();
  if (pesquisa.codInstituicao !== "0") params.BancoId = pesquisa.codInstituicao;
  if (pesquisa.produtoRiberId !== "0")
    params.ProdutoId = pesquisa.produtoRiberId;
  if (pesquisa.codConvenio !== "0") params.ConvenioId = pesquisa.codConvenio;
  if (pesquisa.codOperacao !== "0") params.TipoOperacaoId = pesquisa.codOperacao;
  if (pesquisa.dataInicioVigencia !== "" && pesquisa.dataFimVigencia !== "") {
    params.DtInicioVig = pesquisa.dataInicioVigencia;
    params.DtFimVig = pesquisa.dataFimVigencia;
  }
  if (ordenacao.campo) {
    params.OrdenarPor = ordenacao.campo;
    params.Direcao = ordenacao.direcao;
  }

  setLoading(true);
  const data = await api.get("tabelaComissao/Paginado", params);
  setLoading(false);

  if (!data.success) {
    return;
  }

  let body = [];
  data.content.registros.forEach((regs) => {
    body.push({
      id: regs.id,
      descricao: regs.descricao,
      banco: regs.banco.nome,
      produto: regs.produtoBanco.produto.nome,
      convenio: regs.convenioBanco.convenio.descricao,
      vigencia: `${formatarData(regs.dtInicioVig)} - ${formatarData(
        regs.dtFimVig
      )}`,
    });
  });
  actions.setComissoes(body);
  actions.setAllItems({
    quantidade: data.content.quantidade,
    quantidadeTotal: data.content.quantidadeTotal,
    totalPaginas: data.content.totalPaginas,
    tamanhoPagina: data.content.tamanhoPagina,
  });
}

export async function getConveniosCadastro(id) {
  if (id === "0") return;

  const data = await api.get(
    `ConveniosBanco/ConvenioInstituicao?idInstituicao=${id}`
  );

  if (!data.success) {
    return;
  }
  actions.setTiposConveniosCadastro(data.content);
}

export async function getTiposOperacaoCadastro(id) {
  if (id === "0") return;

  const data = await api.get(
    `tipos-operacao-banco/TipoOperacaoInstituicao?idInstituicao=${id}`
  );

  if (!data.success) {
    return;
  }
  actions.setTiposOperacaoCadastro(data.content);
}

export async function getProdutosCadastro(id) {
  if (id === "0") return;

  const data = await api.get(
    `ProdutoBanco/ProdutoInstituicao?idInstituicao=${id}`
  );

  if (!data.success) {
    return;
  }
  actions.setProdutosCadastro(data.content);
}

export async function getInstituicoes() {
  const data = await api.get("bancos");

  if (!data.success) {
    return;
  }
  actions.setInstituicoes(data.content);
}

export async function getProdutosInstituicao(bancoId) {
  const data = await api.get(
    `ProdutoBanco/ProdutoInstituicao?idInstituicao=${bancoId}`
  );

  if (!data.success) {
    return;
  }
  actions.setProdutosInstituicao(data.content);
}

export async function getConveniosInstituicao(bancoId) {
  const data = await api.get(
    `ConveniosBanco/ConvenioInstituicao?idInstituicao=${bancoId}`
  );

  if (!data.success) {
    return;
  }
  actions.setConveniosInstituicao(data.content);
}

export async function getTiposOperacaoInstituicao(bancoId) {
  const data = await api.get(
    `tipos-operacao-banco/TipoOperacaoInstituicao?idInstituicao=${bancoId}`
  );

  if (!data.success) {
    return;
  }
  actions.setTiposInstituicao(data.content);
}

export async function getProdutos() {
  const data = await api.get("produtoBanco");

  if (!data.success) {
    return;
  }
  actions.setProdutos(data.content);
}

export async function getProdutosRiber() {
  const data = await api.get("Produtos");

  if (!data.success) {
    return;
  }
  actions.setProdutosRiber(data.content);
}

export async function getConvenios() {
  const data = await api.get("convenios");

  if (!data.success) {
    return;
  }
  actions.setConvenios(data.content);
}

export async function getTiposComissaoBanco(bancoId) {
  setLoading(true);
  const data = await api.get(
    `tipoComissao/GetByInstituicao?idInstituicao=${bancoId}`
  );
  setLoading(false);

  if (!data.success) {
    return;
  }

  let dataFormated = [];

  data.content.forEach((comissao) => {
    dataFormated.push({
      id: comissao.tiposComissaoBanco[0].id,
      descricao: comissao.descricao,
      unidadeComissao: comissao.tiposComissaoBanco[0].unidadeComissao,
    });
  });

  actions.setTiposComissaoBanco(dataFormated);
}

export async function getTiposComissaoProdutoBanco(produtoBancoId) {
  setLoading(true);
  const data = await api.get(
    `ProdutoBanco/${produtoBancoId}/tipo-comissao-banco`
  );
  setLoading(false);

  if (!data.success) {
    return;
  }

  let dataFormated = [];

  data.content.forEach((comissao) => {
    dataFormated.push({
      id: comissao.id,
      descricao: comissao.descricao,
      unidadeComissao: comissao.unidadeComissao,
    });
  });

  actions.setTiposComissaoBanco(dataFormated);
}

export async function getTiposOperacao() {
  const data = await api.get("tipos-operacao");

  if (!data.success) {
    return;
  }

  actions.setTiposOperacao(data.content);
}

export async function getById(id) {
  setLoading(true);
  const data = await api.get(`tabelaComissao/${id}`);
  setLoading(false);

  if (!data.success) {
    return false;
  }

  data.content.tabelaComissaoEventos.forEach((e) => {
    e.valor = maskMoeda(Number(e.valor).toFixed(2));
    e.unidade = e.tiposComissaoBanco.unidade;
  });

  const dataUpdate = {
    id: data.content.id,
    descricao: data.content.descricao,
    bancoId: data.content.bancoId,
    produtoBancoId: data.content.produtoBancoId,
    convenioBancoId: data.content.convenioBancoId,
    tipoOperacaoBancoId: data.content.tipoOperacaoBancoId,
    codigoTabela: data.content.codigoTabela,
    dtInicioVig: maskDate(data.content.dtInicioVig, "YYYY-MM-DD"),
    dtFimVig: data.content.dtFimVig
      ? maskDate(data.content.dtFimVig, "YYYY-MM-DD")
      : "",
    tabelaComissaoEventos: data.content.tabelaComissaoEventos,
  };

  getProdutosCadastro(dataUpdate.bancoId);
  getConveniosCadastro(dataUpdate.bancoId);
  getTiposOperacaoCadastro(dataUpdate.bancoId);

  actions.setCopia(cloneDeep(dataUpdate));
  actions.setRegistros(dataUpdate);
  return true;
}

async function getTabelasInstituicao(bancoId) {
  setLoading(true);
  const data = await api.get("tabelaComissao/Inst", { idInst: bancoId });
  setLoading(false);

  if (!data.success) {
    return null;
  }
  return data.content || [];
}

export async function getIdTabelaPorCodigo(
  bancoId,
  codigoTabela,
  dataReferencia
) {
  const params = { bancoId, codigoTabela: codigoTabela.trim() };
  if (dataReferencia) params.dataReferencia = dataReferencia;

  setLoading(true);
  const data = await api.get("tabelaComissao/PorCodigo", params);
  setLoading(false);

  if (!data.success || !data.content) return null;
  return data.content.id;
}

async function validarSobreposicaoVigencia(registro) {
  const tabelas = await getTabelasInstituicao(registro.bancoId);
  if (!tabelas) return false;

  const inicio = registro.dtInicioVig;
  const fim = registro.dtFimVig || null;

  const conflito = tabelas.find((t) => {
    if (registro.id && mesmoId(t.id, registro.id)) return false;
    if (
      !mesmoId(t.produtoBancoId, registro.produtoBancoId) ||
      !mesmoId(t.convenioBancoId, registro.convenioBancoId) ||
      !mesmoId(t.tipoOperacaoBancoId, registro.tipoOperacaoBancoId)
    ) {
      return false;
    }
    const tInicio = t.dtInicioVig.substring(0, 10);
    const tFim = t.dtFimVig ? t.dtFimVig.substring(0, 10) : null;
    return (tFim === null || inicio <= tFim) && (fim === null || tInicio <= fim);
  });

  if (conflito) {
    const vigencia = conflito.dtFimVig
      ? `de ${formatarData(conflito.dtInicioVig)} a ${formatarData(
          conflito.dtFimVig
        )}`
      : `a partir de ${formatarData(conflito.dtInicioVig)}, sem vigência final`;
    actions.setInvalid("dtFimVig");
    notifyWarn(
      `A vigência informada sobrepõe a tabela "${conflito.descricao}" (código ${conflito.codigoTabela}), vigente ${vigencia}, da mesma instituição, produto, convênio e tipo de operação.`
    );
    return false;
  }
  return true;
}

function validarEventos(eventos, tiposComissaoBanco) {
  if (eventos.length === 0) {
    notifyWarn("Insira ao menos um evento");
    return false;
  }

  if (tiposComissaoBanco.length === 0) return true;

  const index = eventos.findIndex(
    (e) =>
      !tiposComissaoBanco.some((t) => mesmoId(t.id, getTipoComissaoBancoId(e)))
  );
  if (index >= 0) {
    const evento = eventos[index];
    notifyWarn(
      `Evento ${index + 1} (meses ${evento.mesesDe} a ${evento.mesesAte}): o tipo de comissão não pertence ao produto da instituição selecionada. Remova o evento e adicione novamente.`
    );
    return false;
  }
  return true;
}

function validarCampos(registro) {
  if (registro.descricao.trim() === "") {
    actions.setInvalid("descricao");
    notifyWarn("Descrição não pode estar em branco");
    return false;
  }

  if (registro.bancoId === "0") {
    actions.setInvalid("bancoId");
    notifyWarn("Selecione uma instituição");
    return false;
  }

  if (registro.produtoBancoId === "0") {
    actions.setInvalid("produtoBancoId");
    notifyWarn("Selecione um produto instituição");
    return false;
  }

  if (registro.convenioBancoId === "0") {
    actions.setInvalid("convenioBancoId");
    notifyWarn("Selecione um convênio instituição");
    return false;
  }

  if (registro.tipoOperacaoBancoId === "0") {
    actions.setInvalid("tipoOperacaoBancoId");
    notifyWarn("Selecione o tipo de operação instituição");
    return false;
  }

  if (registro.dtInicioVig === "") {
    actions.setInvalid("dtInicioVig");
    notifyWarn("Informe a Data Inicio da Vigência");
    return false;
  }

  if (registro.dtFimVig !== "" && registro.dtInicioVig > registro.dtFimVig) {
    notifyWarn("Data Inicial não pode ser maior que Data Final");
    return false;
  }

  if (registro.codigoTabela.trim() === "") {
    actions.setInvalid("codigoTabela");
    notifyWarn("Código da tabela não pode estar em branco");
    return false;
  }

  return true;
}

function montarPayload(registro) {
  return {
    ...registro,
    dtFimVig: registro.dtFimVig === "" ? null : registro.dtFimVig,
    tabelaComissaoEventos: registro.tabelaComissaoEventos.map((e) => ({
      id: e.id,
      impedeRepasse: e.impedeRepasse,
      mesesAte: e.mesesAte,
      mesesDe: e.mesesDe,
      tabelaComissaoId: e.tabelaComissaoId,
      tiposComissaoBancoId: getTipoComissaoBancoId(e),
      valor: removeMaskMoeda(e.valor),
    })),
  };
}

export async function create(registro, tiposComissaoBanco) {
  if (!validarCampos(registro)) return false;
  if (!validarEventos(registro.tabelaComissaoEventos, tiposComissaoBanco))
    return false;
  if (!(await validarSobreposicaoVigencia(registro))) return false;

  setLoading(true);
  const data = await api.post("tabelaComissao", montarPayload(registro));
  setLoading(false);

  if (!data.success) {
    return false;
  }

  notifySuccess("Tabela cadastrada");
  actions.cleanRegister();
  actions.cleanSearch();
  actions.setActiveTab("Search");
  actions.setRecarregarBusca(true);
  return true;
}

export async function update(registro, copia, tiposComissaoBanco) {
  if (JSON.stringify(registro) === JSON.stringify(copia)) {
    notifyInfo("Nada foi alterado");
    actions.setActiveTab("Search");
    return true;
  }

  if (!validarCampos(registro)) return false;
  if (!validarEventos(registro.tabelaComissaoEventos, tiposComissaoBanco))
    return false;
  if (!(await validarSobreposicaoVigencia(registro))) return false;

  setLoading(true);
  const data = await api.put(
    `tabelaComissao/${registro.id}`,
    montarPayload(registro)
  );
  setLoading(false);

  if (!data.success) {
    return false;
  }

  notifySuccess("Tabela atualizada");
  actions.cleanRegister();
  actions.setActiveTab("Search");
  actions.setRecarregarBusca(true);
  return true;
}

export async function remove(id) {
  setLoading(true);
  const data = await api.delete(`tabelaComissao/${id}`);
  setLoading(false);

  if (!data.success) {
    return;
  }

  notifySuccess("Tabela removida");
  actions.setRecarregarBusca(true);
}
